import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "map-elem-info movie" }
const _hoisted_2 = { class: "col-info" }
const _hoisted_3 = { class: "row1 mb6" }
const _hoisted_4 = {
  key: 0,
  class: "left-side"
}
const _hoisted_5 = { class: "ib val" }
const _hoisted_6 = { class: "ib val" }
const _hoisted_7 = {
  key: 0,
  class: "ib val"
}
const _hoisted_8 = { class: "ib val" }
const _hoisted_9 = { class: "ib val" }
const _hoisted_10 = {
  key: 0,
  class: "ib val ml2"
}
const _hoisted_11 = { class: "ib val" }
const _hoisted_12 = {
  key: 1,
  class: "right-side mr8"
}
const _hoisted_13 = { class: "ib val" }
const _hoisted_14 = { class: "row2" }
const _hoisted_15 = { class: "left-side" }
const _hoisted_16 = { class: "buttons ta-right mr8" }
const _hoisted_17 = ["disabled"]

import {
  ref,
  computed,
} from 'vue';
import type { MapElemInfo } from 'src/models';
import type { GIMovieList } from 'src/models/geoItem';
import type { MovieTag } from 'src/models/movie';
import useUpdateTimer from 'src/composables/useUpdateTimer';
import { dtFormat, fuzzyTimeDisp } from 'src/lib/dateHelper';

interface Props {
  elem: MapElemInfo<GIMovieList>;
}

const startIconPath = '/static/img/movie_start_pin.png';
const endIconPath = '/static/img/movie_end_pin.png';


export default /*@__PURE__*/_defineComponent({
  __name: 'MapElemInfoMovie',
  props: {
    elem: {}
  },
  emits: ['play-movie', 'edit-movie-tag'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const movieList = computed<GIMovieList>(() => props.elem.data);
const now = ref<Date>(new Date());
useUpdateTimer(now);

const isSearchTypeRoute = computed<boolean>(() => {
  return movieList.value.searchType === 'route';
});
const showStartTsFuzzy = computed<boolean>(() => {
  const secDiff = (now.value.valueOf() - (movieList.value.startTs?.valueOf() ?? 0)) / 1000;
  return secDiff < 86400 * 31;
});
const startTsFuzzy = computed<string>(() => {
  return fuzzyTimeDisp(movieList.value.startTs, now.value);
});
const movieTags = computed<MovieTag[]>(() => {
  const movieTagMap = movieList.value.movies.reduce((acc: Record<string, MovieTag>, movie) => {
    movie.tags.forEach(tag => { acc[tag.id] = tag; }); return acc;
  }, {});
  return Object.values(movieTagMap);
});

const play = () => {
  emit('play-movie', { dataName: 'movie', data: movieList.value });
};
const editMovieTag = () => {
  emit('edit-movie-tag', { dataName: 'movie', data: movieList.value });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "col-icon" }, [
      _createElementVNode("img", {
        class: "resource-icon start",
        src: startIconPath
      }),
      _createElementVNode("img", {
        class: "resource-icon end",
        src: endIconPath
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (movieList.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "ib lbl" }, "場所:", -1)),
                _createElementVNode("span", _hoisted_5, _toDisplayString(movieList.value.startKp.roadNameDispShort), 1),
                _createElementVNode("span", _hoisted_6, _toDisplayString(movieList.value.startKp.direction), 1),
                (movieList.value.startKp.placeName !== 'main_line')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(movieList.value.startKp.placeName), 1))
                  : _createCommentVNode("", true),
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "ib lbl ml12" }, "KP:", -1)),
                _createElementVNode("span", _hoisted_8, _toDisplayString(movieList.value.startKp.kp.toFixed(1)) + "~" + _toDisplayString(movieList.value.endKp.kp.toFixed(1)), 1)
              ]),
              _createElementVNode("div", null, [
                (!isSearchTypeRoute.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "ib lbl" }, "日時:", -1)),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(dtFormat)(movieList.value.startTs, 'yyyy/mm/dd HH:MM:SS')) + " ~ " + _toDisplayString(_unref(dtFormat)(movieList.value.endTs, 'HH:MM:SS')), 1),
                      (showStartTsFuzzy.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, " (" + _toDisplayString(startTsFuzzy.value) + ") ", 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "ib lbl" }, "再生時間:", -1)),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(dtFormat)(movieList.value.endTs, 'HH:MM:SS')), 1)
                    ], 64))
              ])
            ]))
          : _createCommentVNode("", true),
        (movieList.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (!isSearchTypeRoute.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "ib lbl" }, "車両番号:", -1)),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(movieList.value.carName), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(movieTags.value, (e, i) => {
            return (_openBlock(), _createElementBlock("span", {
              class: _normalizeClass(["tag-badge mr4 mb4", 'tag-badge-' + e.tagType1]),
              key: i
            }, _toDisplayString(e.tagName), 3))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            type: "button",
            key: "play",
            class: "btn btn-sm btn-primary",
            onClick: play
          }, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("i", { class: "fas fa-play" }, null, -1),
            _createTextVNode(" 再生 ", -1)
          ]))]),
          _createElementVNode("button", {
            type: "button",
            key: "editMovieTag",
            class: "btn btn-sm btn-info ml4",
            onClick: editMovieTag,
            disabled: isSearchTypeRoute.value
          }, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("i", { class: "fas fa-tag" }, null, -1),
            _createTextVNode(" タグ編集 ", -1)
          ]))], 8, _hoisted_17)
        ])
      ])
    ])
  ]))
}
}

})